"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import * as Aria from 'react-aria-components';

const ContextMenuContent = (props) => /* @__PURE__ */ jsx(Aria.Menu, { ...props });

export { ContextMenuContent, ContextMenuContent as default };
//# sourceMappingURL=ContextMenuContent.mjs.map
